import React, { useEffect, useState } from "react"
import { useHistory } from "react-router"
import Button from "../../../../components/Button"
import "./AutomaticIDGeneration.scss"
import InputEntry from "./components/InputEntry"
import {
  getAllCenters, updateCenterDetail
} from "../../../../core/services/api"
import Toast from "components/Toast"
import Select from "react-select"
import { useSelector } from "react-redux"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"


export default function AutomaticIDGeneration() {
  const history = useHistory()
  const tabs = ["Patient ID Generation", "Invoice ID Generation", "Receipt ID Generation", "Appointment ID Generation"];
  const [selectedTab, updateSelectedTab] = useState<any>("Patient ID Generation");

  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);

  const [patientIDGen, updatePatientIDGen] = useState<any>();
  const [invoiceIDGen, updateInvoiceIDGen] = useState<any>();
  const [receiptIDGen, updateReceiptIDGen] = useState<any>();
  const [appointmentIdGen, updateAppointmentIdGen] = useState<any>();
  const [location, setLocation] = useState<any>("");
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const [centers, setCenters] = useState<any>();
  const [isLocation, setIsLocation] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false)

  useEffect(() => {
    getAllCenters()
      .then((res: any) => {
        setCenters(res)
        const temp = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.centerName }
        })
        setLocationOptions(temp)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    //Center specific details
    if (centers?.length > 0) {
      const locationObj = centers.find((each: any) => each?.centerName === location)
      //Patient ID
      if (locationObj?.patientIdInfo) {
        updatePatientIDGen({ numericValue: locationObj?.patientIdInfo?.startPoint, prefixValue: locationObj?.patientIdInfo?.prefix })
      } else {
        updatePatientIDGen({ numericValue: "", prefixValue: "" })
      }
      //Receipt ID
      if (locationObj?.receiptIdInfo) {
        updateReceiptIDGen({ numericValue: locationObj?.receiptIdInfo?.startPoint, prefixValue: locationObj?.receiptIdInfo?.prefix })
      } else {
        updateReceiptIDGen({ numericValue: "", prefixValue: "" })
      }
      //Invoice ID
      if (locationObj?.invoiceIdInfo) {
        updateInvoiceIDGen({ numericValue: locationObj?.invoiceIdInfo?.startPoint, prefixValue: locationObj?.invoiceIdInfo?.prefix })
      } else {
        updateInvoiceIDGen({ numericValue: "", prefixValue: "" })
      }
      //Appointment ID
      if (locationObj?.appointmentIdInfo) {
        updateAppointmentIdGen({ numericValue: locationObj?.appointmentIdInfo?.startPoint, prefixValue: locationObj?.appointmentIdInfo?.prefix })
      } else {
        updateAppointmentIdGen({ numericValue: "", prefixValue: "" })
      }
    }
  }, [location])

  function onSubmit() {
    if (location === "") {
      setIsLocation(true)
    } else {
      //API to update the corresponding center details
      const locationObj = centers.find((each: any) => each?.centerName === location)
      locationObj.invoiceIdInfo = {
        "prefix": invoiceIDGen?.prefixValue,
        "startPoint": invoiceIDGen?.numericValue,
      }
      locationObj.patientIdInfo = {
        "prefix": patientIDGen?.prefixValue,
        "startPoint": patientIDGen?.numericValue,
      }
      locationObj.receiptIdInfo = {
        "prefix": receiptIDGen?.prefixValue,
        "startPoint": receiptIDGen?.numericValue,
      }
      locationObj.appointmentIdInfo = {
        "prefix": appointmentIdGen?.prefixValue,
        "startPoint": appointmentIdGen?.numericValue,
      }
      updateCenterDetail(locationObj?.id, locationObj)
        .then((res: any) => {
          setSuccess(true)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  return (
    <div className="automatic-id-generation-wrapper">
      {
        isLocation ? (
          <Toast
            textMessage="Please select the location"
            type="error"
            onCloseText={"Close"}
            onClose={() => setIsLocation(false)}
          ></Toast>
        ) : success ? (
          <Toast
            textMessage="Details saved successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => setSuccess(false)}
          ></Toast>
        ) : null
      }
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>

        <div className="header-text">Automatic ID Generation</div>
      </div>

      <div className="automatic-id-generation-content">
        <label style={{ fontWeight: '800', letterSpacing: '1.25px', paddingBottom: '5px' }}>Location</label>
        <Select
          onChange={(option: any) => {
            setLocation(option?.value)
          }}
          value={locationOptions.filter(
            ({ value }: any) => value === location
          )}
          styles={customSelectStyles()}

          options={locationOptions}
        />
      </div>

      <div className="automatic-id-generation-content">

        <div className="tab-wrapper">
          {
            tabs?.map((eachTab) => (
              <div className={`tab ${selectedTab === eachTab ? "active" : "inactive"}`} onClick={() => updateSelectedTab(eachTab)}>
                <div className="tab-title">
                  {eachTab}
                </div>
              </div>
            ))
          }
        </div>

        <div className="tab-content-wrapper">
          {selectedTab === "Patient ID Generation" ? renderPatientID() : null}
          {selectedTab === "Invoice ID Generation" ? renderInvoiceID() : null}
          {selectedTab === "Receipt ID Generation" ? renderReceiptID() : null}
          {selectedTab === "Appointment ID Generation" ? renderAppointmentID() : null}
        </div>

        <div className="button-section">
          <div className="me-3">
            <Button
              outline={true}
              text="Cancel"
              type={"button"}
              disabled={readOnly}
              onClick={() => history.goBack()}
              id="automatic-id-generation-cancel"
            />
          </div>
          <Button type="primary"
            disabled={readOnly}
            text="Save" onClick={() => onSubmit()} id="automatic-id-generation-save" />
        </div>
      </div>
    </div>
  )

  function renderPatientID() {
    return (
      <div className="tab-content">
        <InputEntry
          title="Patient ID Prefix :"
          prefix="Patient ID Prefix (Optional)"
          numeric="Numeric Only"

          prefixValue={patientIDGen?.prefixValue}
          numericValue={patientIDGen?.numericValue}
          readOnly={readOnly}
          onNumericValueChange={(value: any) => {
            const values = parseFloat(value);
            if (!isNaN(values) && values > 0) {
              updatePatientIDGen({ ...patientIDGen, ...{ numericValue: values } });
            } else {
              updatePatientIDGen({ ...patientIDGen, ...{ numericValue: '' } });
            }

          }}
          onPrefixValueChange={(value: any) => {
            updatePatientIDGen({ ...patientIDGen, ...{ prefixValue: value } })
          }}
        />
      </div>
    )
  }

  function renderInvoiceID() {
    return (
      <div className="tab-content">
        <div className="description">
          You need to select an initial value. You can choose an alphanumeric prefix (will not be incremented), and a numeric part which will be automatically incremented for every new bill.
        </div>
        <InputEntry
          title="Invoice ID Prefix :"
          prefix="Invoice ID Prefix (Optional)"
          numeric="Numeric Only"
          prefixValue={invoiceIDGen?.prefixValue}
          readOnly={readOnly}
          numericValue={invoiceIDGen?.numericValue}
          onNumericValueChange={(value: any) => {
            // updateInvoiceIDGen({ ...invoiceIDGen, ...{ numericValue: Number(value) } })
            const values = parseFloat(value);
            if (!isNaN(values) && values > 0) {
              updateInvoiceIDGen({ ...invoiceIDGen, ...{ numericValue: values } });
            } else {
              updateInvoiceIDGen({ ...invoiceIDGen, ...{ numericValue: '' } });
            }
          }}
          onPrefixValueChange={(value: any) => {
            updateInvoiceIDGen({ ...invoiceIDGen, ...{ prefixValue: value } })
          }}

        />
      </div>
    )
  }

  function renderReceiptID() {
    return (
      <div className="tab-content">
        <div className="description">
          You need to select an initial value. You can choose an alphanumeric prefix (will not be incremented), and a numeric part which will be automatically incremented for every new receipt.
        </div>
        <InputEntry
          title="Receipt ID Prefix :"
          prefix="Receipt ID Prefix (Optional)"
          numeric="Numeric Only"
          readOnly={readOnly}
          prefixValue={receiptIDGen?.prefixValue}
          numericValue={receiptIDGen?.numericValue}
          onNumericValueChange={(value: any) => {
            // updateReceiptIDGen({ ...receiptIDGen, ...{ numericValue: Number(value) } })
            const values = parseFloat(value);
            if (!isNaN(values) && values > 0) {
              updateReceiptIDGen({ ...receiptIDGen, ...{ numericValue: values } });
            } else {
              updateReceiptIDGen({ ...receiptIDGen, ...{ numericValue: '' } });
            }
          }}
          onPrefixValueChange={(value: any) => {
            updateReceiptIDGen({ ...receiptIDGen, ...{ prefixValue: value } })
          }}
        />
      </div>
    )
  }

  function renderAppointmentID() {
    return (
      <div className="tab-content">
        <InputEntry
          title="Appointment ID Prefix :"
          prefix="Appointment ID Prefix (Optional)"
          numeric="Numeric Only"
          readOnly={readOnly}
          prefixValue={appointmentIdGen?.prefixValue}
          numericValue={appointmentIdGen?.numericValue}
          onNumericValueChange={(value: any) => {
            // updateReceiptIDGen({ ...receiptIDGen, ...{ numericValue: Number(value) } })
            const values = parseFloat(value);
            if (!isNaN(values) && values > 0) {
              updateAppointmentIdGen({ ...appointmentIdGen, ...{ numericValue: values } });
            } else {
              updateAppointmentIdGen({ ...appointmentIdGen, ...{ numericValue: '' } });
            }
          }}
          onPrefixValueChange={(value: any) => {
            updateAppointmentIdGen({ ...appointmentIdGen, ...{ prefixValue: value } })
          }}
        />
      </div>
    )
  }
}
